var map = {
	"./collection_grey.svg": 256,
	"./collection_white.svg": 257,
	"./company_grey.svg": 258,
	"./company_white.svg": 259,
	"./composting_grey.svg": 260,
	"./composting_white.svg": 261,
	"./factory2_white.svg": 262,
	"./factory_grey.svg": 263,
	"./factory_white.svg": 264,
	"./limited_resources_grey.svg": 265,
	"./limited_resources_white.svg": 266,
	"./own_channel_grey.svg": 267,
	"./own_channel_white.svg": 268,
	"./plus.svg": 269,
	"./product_service_system.svg": 270,
	"./recycling_grey.svg": 271,
	"./recycling_white.svg": 272,
	"./repair_service_grey.svg": 273,
	"./repair_service_white.svg": 274,
	"./reusability.svg": 275,
	"./stores_grey.svg": 276,
	"./stores_white.svg": 277,
	"./unlimited_resources_bio_white.svg": 278,
	"./unlimited_resources_grey.svg": 279,
	"./unlimited_resources_white.svg": 280,
	"./users_grey.svg": 281,
	"./users_white.svg": 282,
	"./waste_grey.svg": 283,
	"./waste_white.svg": 284
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model/sector-icons nonrecursive \.svg$
// module id = 225
// module chunks = 2 3 5 6